import React from "react";
import DosOverTimeReport from "./Report";
import View from "common/View";
import help from "help/viewDosStatsTime.md";

const DoSOverTimeStats = () => (
  <View title="DoS attacks over time" mdHelp={help}>
    <DosOverTimeReport />
  </View>
);

export default DoSOverTimeStats;
